import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import { ApolloProvider } from '@apollo/client'

import App from './App'

import { client } from 'gql'
import { AuthProvider } from 'context/Auth'

import 'styles-byfi/src/bootstrap.css'
import { MainStylesByfi, ThemeByfi } from 'styles-byfi'

// Fix for @react-pdf/renderer font loader losing `window` context when calling fetch.
// cross-fetch (dep transitiva) exporta window.fetch sin enlazar a window; al invocarlo
// suelto el navegador lanza "Failed to execute 'fetch' on 'Window': Illegal invocation".
// Imprescindible para generar cualquier PDF (descargar o enviar factura por email).
window.fetch = window.fetch.bind(window)

ReactDOM.render(
  <BrowserRouter>
    <ApolloProvider client={client}>
      <ThemeProvider theme={ThemeByfi}>
        <AuthProvider>
          <MainStylesByfi>
            <App />
          </MainStylesByfi>
        </AuthProvider>
      </ThemeProvider>
    </ApolloProvider>
  </BrowserRouter>,
  document.getElementById('root')
)
